import Trolley from '@mui/icons-material/ShoppingCart';
import { GuardedComponents } from '../../lib/permissions/types';
import { ResourceDefinition } from '../types';
import { ProductCreate, ProductEdit, ProductList } from '.';

export default {
  permissionResource: 'Product',
  name: 'productvariants',
  icon: Trolley,
  components: new GuardedComponents([
    ['list', { action: 'GetList', component: ProductList, onlyBeursGoes: true }],
    ['edit', { action: 'Update', component: ProductEdit, onlyBeursGoes: true }],
    ['create', { action: 'Create', component: ProductCreate, onlyBeursGoes: true }],
  ]),
  i18n: {
    nl: {
      name: 'Product |||| Producten',
      fields: {
        existing: "Bestaand product",
        name: 'Nieuw product',
        product: 'Product',
        variant: "Variant",
        unit: "Prijs eenheid"
      },
    },
  },
} as ResourceDefinition;
